<template>
<v-app>
  <Navbar/>

  <v-app-bar
    app
    clipped-left
    :color="barColor"
    >
    <v-toolbar-title class="headline text-uppercase">
      <span>WMS</span>
      <span class="font-weight-light">Dashboard</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-toolbar-items>
      <v-btn text v-if="this.$store.getters.authed" @click="logout">Logout</v-btn>
      
      <v-btn text v-if="this.$store.getters.authed" @click="refresh">Refresh</v-btn>

      <v-btn icon @click.stop="toggleMiniVariant()">
        <v-icon v-html="miniVariant ? 'fa-bars' : 'fa-chevron-left'"></v-icon>
      </v-btn>

    </v-toolbar-items>

  </v-app-bar>

  <v-content v-if="$store.getters.authed">
    <transition name="slide-x-transition">
      <!-- <keep-alive exclude="PointsViewerCMP"> -->
        <router-view></router-view>
      <!-- </keep-alive> -->
    </transition>
  </v-content>

  <v-content v-else>
    <Login/>
  </v-content>

  <notifications
    group="ui"
    position="bottom right"
    width="500"
    classes="vue-notification"
    />
</v-app>
</template>

<script>
import Navbar from './components/Navbar.vue';
import Login from './components/Login.vue';

import { config } from './config';

export default {
    name: 'App',
    components: {
        Navbar,
        Login,
    },
    data: () => ({
        //
    }),

    methods: {
        logout() {
            this.$store.commit('UPDATE_CREDS', { username: '', password: '' });
            this.$store.commit('TOGGLE_AUTH');
        },

        toggleMiniVariant() {
            this.$store.commit('TOGGLE_MINI_VARIANT');
        },

	refresh() {
	    const url = `${config.baseUrl}refresh`;
	    
            this.$http.get(url, { auth: this.$store.getters.auth , timeout: 1000000 }).then((res) => {
		vm.$forceUpdate();
		
            }).catch((err) => {
                console.log(err);
            });
	},
    },

    computed: {
        barColor() {
            return process.env.VUE_APP_ENV ? 'red' : '';
        },

        miniVariant() {
            return this.$store.getters.miniVariant;
        },

    },
};
</script>


<style lang="scss">
.vue-notification {
  padding: 10px;
  margin: 0 5px 5px;

  font-size: 20px;

  color: #ffffff;
  background: #44A4FC;
  border-left: 10px solid #187FE7;

  &.warn {
    background: #ffb648;
    border-left-color: #f48a06;
  }

  &.error {
    background: #E54D42;
    border-left-color: #B82E24;
  }

  &.success {
    background: #68CD86;
    border-left-color: #42A85F;
  }
}
</style>
